import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export const fmtP = (n) => (n ?? 0).toLocaleString("de-DE");

export const MEGA_IMG = {
  ps5: "https://images.unsplash.com/photo-1607853202273-797f1c22a38e?crop=entropy&cs=srgb&fm=jpg&w=640&q=80",
  iphone: "https://images.unsplash.com/photo-1727013884184-b313982327f3?crop=entropy&cs=srgb&fm=jpg&w=640&q=80",
};

export const SEGMENTS = ["plus", "minus", "double", "minus", "plus", "bankrupt", "minus", "plus", "minus", "halve", "minus", "plus"];
export const SEG_LABEL = { plus: "+1.000", minus: "−1.000", double: "×2", halve: "÷2", bankrupt: "BANKROTT" };

export const ACTIVE_PHASES = ["upcoming", "live", "closing"];

export function useJackpot(fastMs = 5000) {
  const [s, setS] = useState(null);
  const [err, setErr] = useState(false);
  const load = useCallback(() => api.get("/jackpot/state").then(({ data }) => { setS(data); setErr(false); }).catch(() => setErr(true)), []);
  const live = s?.phase === "live" || s?.phase === "closing";
  useEffect(() => {
    load();
    const i = setInterval(load, live ? fastMs : 30000);
    window.addEventListener("jr-refresh", load);
    return () => { clearInterval(i); window.removeEventListener("jr-refresh", load); };
  }, [load, live, fastMs]);
  return { s, setS, err, load };
}

export function useCountdown(at) {
  const [t, setT] = useState(Date.now());
  useEffect(() => { const i = setInterval(() => setT(Date.now()), 1000); return () => clearInterval(i); }, []);
  const sec = at ? Math.max(0, Math.floor((new Date(at) - t) / 1000)) : 0;
  return { d: Math.floor(sec / 86400), h: Math.floor((sec % 86400) / 3600), m: Math.floor((sec % 3600) / 60), s: sec % 60, sec };
}

export function useAnimatedNumber(value, ms = 900) {
  const [v, setV] = useState(value ?? 0);
  const from = useRef(value ?? 0);
  useEffect(() => {
    if (value == null) return undefined;
    const start = performance.now(), a = from.current, b = value;
    let raf;
    const step = (t) => {
      const p = Math.min(1, (t - start) / ms), e = 1 - Math.pow(1 - p, 3);
      setV(Math.round(a + (b - a) * e));
      if (p < 1) raf = requestAnimationFrame(step); else from.current = b;
    };
    raf = requestAnimationFrame(step);
    return () => { cancelAnimationFrame(raf); from.current = b; };
  }, [value, ms]);
  return v;
}

export const pad = (n) => String(n).padStart(2, "0");

export const PROMO = [
  { id: "story", label: "Story 9:16", hint: "WhatsApp-Status, Instagram-Story, Reels, TikTok", src: "/itzcouple-jackpot-roulette-hochformat.mp4?v=4", poster: "/itzcouple-jackpot-roulette-hochformat.jpg?v=4", file: "itzcouple-jackpot-roulette-story.mp4", ratio: "aspect-[9/16] max-h-[52vh]" },
  { id: "post", label: "Beitrag 1:1", hint: "Instagram- & Facebook-Beitrag, WhatsApp-Chat", src: "/itzcouple-jackpot-roulette.mp4?v=4", poster: "/itzcouple-jackpot-roulette.jpg?v=4", file: "itzcouple-jackpot-roulette.mp4", ratio: "aspect-square max-h-[52vh]" },
];
